import request from 'utils/request';
import { DictionaryDto, PagedView } from './dictionary';

export const fetchLanguages = (): Promise<PagedView<DictionaryDto>> => {
    return request
        .get('/language/list', { params: { page: 0, size: 1000, sort: 'id,asc', value: '' } })
        .then(({ data }) => data as PagedView<DictionaryDto>);
};
